import { CIcon } from '~/icons/types'
export const ciBicycleChildren: CIcon = {
  width: 24,
  height: 24,
  paths: [
    {
      d:
        'M18.953 11.715c-.34.003-.68.044-1.01.123l-3.664-8.6a.687.687 0 0 0-.834-.387l-4.93 1.523a.687.687 0 1 0 .406 1.312l4.337-1.34 2.444 5.737a6.613 6.613 0 0 0-3.572 1.531 9.954 9.954 0 0 0-1.918 2.38 10.38 10.38 0 0 1-1.517 1.97L7.32 13.407a5.676 5.676 0 0 0 2.023-.996.686.686 0 1 0-.84-1.087 4.23 4.23 0 0 1-2.288.881 4.299 4.299 0 0 1-2.824-.843 4.614 4.614 0 0 1-1.153-5.066.687.687 0 0 0-1.304-.432A5.983 5.983 0 0 0 2.53 12.43a5.572 5.572 0 0 0 3.326 1.15L7.6 16.832c-.461.287-.96.512-1.48.667a2.851 2.851 0 1 0 .066 1.405 7.511 7.511 0 0 0 2.625-1.246l.012-.003a.62.62 0 0 0 .056-.046c.094-.07.193-.132.285-.208.88-.759 1.625-1.66 2.205-2.667.442-.773 1-1.473 1.654-2.077a5.274 5.274 0 0 1 3.24-1.255l.405.952a4.516 4.516 0 1 0 2.284-.639ZM3.375 19.81a1.5 1.5 0 1 1 0-3.001 1.5 1.5 0 0 1 0 3.001Zm15.578-.375a3.17 3.17 0 0 1-1.746-5.817l1.114 2.617a.687.687 0 0 0 1.264-.538l-1.09-2.56c.151-.027.305-.043.458-.047a3.173 3.173 0 0 1 0 6.345Z'
    }
  ],
  name: 'bicycle-children',
  type: 'thin'
}
